<div class="mb-3">
  <label class="form-label fw-semibold text-label">
    Supervisor @if(!disabled) { <span class="required-dot">●</span> }
  </label>

  @if(disabled) {
  <div class="picker-box empty-state disabled-state d-flex align-items-center justify-content-between p-3">
    <div class="d-flex align-items-center gap-2">
      <span class="state-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#a09ea5" class="bi bi-slash-circle" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
          <path d="M11.354 4.646a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 .708.708l6-6a.5.5 0 0 0 0-.708"/>
        </svg>
      </span>
      <span class="status-text text-muted">
        {{ disabledMessage || 'Not applicable' }}
      </span>
    </div>
  </div>
  } @else {
    @if(!supervisor) {
    <div class="picker-box empty-state d-flex align-items-center justify-content-between p-3"
      [class.has-error]="hasError">
      <div class="d-flex align-items-center gap-2">
        <!-- On error show red icon '!' else show '+' icon -->
        <span class="state-icon">
          @if(!hasError) {
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#a09ea5" class="bi bi-plus-lg"
            viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
          </svg>
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#E53E3E"
            class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
          </svg>
          }
        </span>
        <span class="status-text" [class.text-danger]="hasError">
          {{ hasError ? 'A supervisor is required for every user' : 'No supervisor assigned' }}
        </span>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-sm pick-btn" (click)="onPick()">Pick supervisor</button>
    </div>
    }

    @if(supervisor) {
    <div class="picker-box filled-state d-flex align-items-center justify-content-between p-3">
      <div class="d-flex align-items-center gap-3">
        <!-- Initials circle -->
        <div class="avatar-circle">
          {{ supervisor.name | initials }}
        </div>
        <div>
          <div class="fw-semibold supervisor-name text-body">{{ supervisor.name }}</div>
          <div class="supervisor-meta">
            {{ supervisor.role }} &middot; {{ supervisor.directReports || 0 }} direct reports
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-link btn-sm change-link" (click)="onPick()">Change</button>
    </div>
    }
  }

  @if(disabled) {
  <div class="form-text text-muted mt-1">Regional Managers do not report to a supervisor.</div>
  } @else {
  <div class="form-text text-muted mt-1">Every user must report to exactly one supervisor.</div>
  }
</div>